module.exports = __webpack_public_path__ + "img/gnome-keyring-manager.cee6134b.png";